import { NuqsAdapter } from "nuqs/adapters/react";

import { RouterProvider, QueryClientProvider } from "./providers";

import { Toaster } from "@/shared/ui/toaster";
import "./styles/global.css";
import "./styles/variables.css";

function App() {
  return (
    <QueryClientProvider>
      <NuqsAdapter>
        <RouterProvider />
        <Toaster />
      </NuqsAdapter>
    </QueryClientProvider>
  );
}

export default App;
